import { render } from "./PageNotAllowed.vue?vue&type=template&id=93428f6c&scoped=true"
import script from "./PageNotAllowed.vue?vue&type=script&lang=js"
export * from "./PageNotAllowed.vue?vue&type=script&lang=js"

import "./PageNotAllowed.vue?vue&type=style&index=0&id=93428f6c&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-93428f6c"]])

export default __exports__